import { createSlice } from '@reduxjs/toolkit';

import initialState from './initialState';

export const modelsInfoSlice = createSlice({
  name: 'modelsInfoSlice',
  initialState,
  reducers: {
    addOrUpdate: (state, action) => {
        const model = state.find(item => item.name === action.payload.name);
        if (model) {
            model.requiredAttributes = action.payload.requiredAttributes;
            model.translatableAttributes = action.payload.translatableAttributes;
        }
        else {
            state.push(action.payload);
        }
    },
  },
});

export const { addOrUpdate } = modelsInfoSlice.actions;

export default modelsInfoSlice.reducer;
